// export const CORE_API_ENDPOINT = "https://api-npi.herokuapp.com"
// 
// // // Localhost 
// export const CORE_API_ENDPOINT = "http://localhost:2800"
// export const REDIRECT_O365_URI = "http://localhost:8080/login"
// export const AX_URL = "http://localhost:8080"

// tracker UAT Server
// export const CORE_API_ENDPOINT = "https://hrmoduletest.cigblusolutions.com/api"
// export const REDIRECT_O365_URI = "https://hrmoduletest.cigblusolutions.com/login"
// export const AX_URL = "https://ciguat.sandbox.operations.dynamics.com"

// tracker Prod Server
export const CORE_API_ENDPOINT = "https://hrmodule.cigblusolutions.com/api"
export const REDIRECT_O365_URI = "https://hrmodule.cigblusolutions.com/login"
// export const AX_URL = "https://cib.operations.dynamics.com"

// export const CORE_API_ENDPOINT = "/api"
// export const REDIRECT_O365_URI = "/login"
export const CORE_GOOGLE_ENDPOINT = "https://hrmoduletest.cigblusolutions.com/google"
export const API_MAP_KEY = "AIzaSyAr0_xNXVux88WH3bK9cyke7J23SlXMRZ0"
//"AIzaSyAdX0Lh7dCs1tV6fVbMMMdSq5UXA6NzCdM"


export const CLIENT_ID = "0b1bf20d-a148-44d2-8932-027dbaf66a46"
export const ACTIVE_ITEM_TAB = 6   //6
export const ACTIVE_ITEM2_TAB = 2   //6
export const VERSION_NO = "1.1.0"
// export const SYSTEM_NAME = `${(CORE_API_ENDPOINT.search("localhost") > -1) || (CORE_API_ENDPOINT.search("test") > -1) ? "trackerUAT" : "trackerPROD"}`
export const SYSTEM_NAME = "hrmodule"



// WEBPACK FOOTER //
// ./src/lib/api.js